<template>
<div>
    <img v-if="!isMobile()" class="navHeader" src="../../assets/nav/Navigation.png" alt="" usemap="#image-map">

    <map name="image-map" v-if="!isMobile()">
        <area target="" @click="FuseBreed()" alt="fuseBreed" title="fuseBreed" href="" coords="53,42,254,83" shape="rect">
        <area target="" @click="Claim()" alt="claim" title="claim" href="" coords="274,44,471,85" shape="rect">
        <area target="" @click="Shop()" alt="shop" title="shop" href="" coords="494,42,693,83" shape="rect">
        <area target="" @click="Home()" alt="home" title="home" href="" coords="745,22,1188,147" shape="rect">
        <area target="" @click="Gallery()" alt="gallery" href="" title="gallery" coords="1236,42,1434,83" shape="rect">
        <area target="" @click="News()" alt="news"  href="" title="news" coords="1456,41,1653,85" shape="rect">
        <area target="" @click="About()" alt="about" title="about" href="" coords="1678,44,1877,83" shape="rect">
    </map>


    <img v-if="isMobile()" id="navMobile" class="navHeaderMobile" src="../../assets/mobile/nav.png" alt="" usemap="#image-map2">

    <map  name="image-map2" v-if="isMobile()">
        <area  alt="burger" title="burger" @click="openNav()" coords="950,6,1058,94" shape="rect">
        <area alt="home" title="home"  @click="Home()" coords="13,8,493,154" shape="rect">
    </map>

    <div id="myNav" class="overlay">
        <a href="javascript:void(0)" class="closebtn" @click="closeNav()">&times;</a>
        <b-container>
            <b-row>
                <b-col cols="12">
                    <div class="overlay-content">
                        <img class="button" @click="FuseBreed()" src="../../assets/mobile/buttons/fuse.png" alt="">
                        <img class="button" @click="Claim()" src="../../assets/mobile/buttons/claim.png" alt="">
                        <img class="button" @click="Shop()" src="../../assets/mobile/buttons/shop.png" alt="">
                        <img class="button" @click="Gallery()" src="../../assets/mobile/buttons/VX.png" alt="">
                        <img class="button" @click="News()" src="../../assets/mobile/buttons/news.png" alt="">
                        <img class="button" @click="About()" src="../../assets/mobile/buttons/about.png" alt="">

                        <a class="linkTree" href="https://linktr.ee/CosmicLabsNFT" target="_blank"><img class="linkTree" src="../../assets/mobile/buttons/linktree.png" alt=""></a>
                    </div>
                </b-col>
            </b-row>
        </b-container>

    </div>

</div>
</template>

<script>
export default {
    mounted()
    {
        $(document).ready(function(e) {
            $('img[usemap]').rwdImageMaps();
        });
    },
    data: function () {
            return {
                
            }
    },
    methods:{
        openNav()
        {
            document.getElementById("myNav").style.width = "100%";
            document.getElementById("navMobile").style.visibility = "hidden"
        },
        closeNav() {
            document.getElementById("myNav").style.width = "0%";
            document.getElementById("navMobile").style.visibility = "visible"
        },
        isMobile() {
            if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                return true
            } else {
                return false
            }
        },
        comingSoon()
        {
            alert("Coming Soon!");
        },
        About()
        {
            console.log("here")
            this.$router.push({ name: 'About' })
        },
        Claim()
        {
            this.$router.push({ name: 'Claim' })
        },
        News()
        {
            window.open('https://docs.cosmic-labs.io/introduction/about');
        },
        Home()
        {
            this.$router.push({ name: 'oldHome' })
        },
        FuseBreed()
        {
            this.$router.push({ name: 'FuseBreed' })
        },
        Shop()
        {
            this.$router.push({ name: 'Shop' })
        },
        Gallery()
        {
            this.$router.push({ name: 'Home' })
        },

    }
}
</script>

<style scoped>
.button
{
    width: 60%;
    opacity: 1;
    border-radius: 999px;
    margin: auto;
    margin-bottom: 2vh;   
}
.linkTree
{
    margin: auto;
}
.navHeader
{
    width: 100%;
    position: absolute; 
    top: 0px;
    left: 0px;
    z-index: 999 !important;
}
.navHeaderMobile
{
    width: 100%;
    position: absolute; 
    top: 0px;
    left: 0px;
    z-index: 999 !important;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.555);
  overflow-x: hidden;
  transition: 1s;
  opacity: 0.9;
}
.overlay-content {
  position: relative;
  top: 20%;
  width: 100%;
  text-align: center;
  margin-top: 20px;
  color: black;
}
.overlay a {
  padding: 8px;
  text-decoration: none;
  font-size: 5vh;
  color: black;
  display: block;
  transition: 0.3s;
}
.overlay a:hover, .overlay a:focus {
  color: #f1f1f1;
}
.overlay .closebtn {
  position: absolute;
  top: 20px;
  right: 45px;
  font-size: 60px;
  color: white;
}
.socialIconBlack
{
    color: white;
}
@media screen and (max-height: 450px) {
  .overlay a {font-size: 20px}
  .overlay .closebtn {
    font-size: 40px;
    top: 15px;
    right: 35px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Navigation/NavBar.vue